import { useEffect, useState } from "react";
import { client } from "../client.js";
import Footer from "../components/Footer.jsx";
import MenuDesktopHorizontal from "../components/MenuDesktopHorizontal";
import OneBlog from "../components/OneBlog.jsx";
import SkeletonBlog from "../components/SkeletonBlog.jsx";

const Blog = () => {
  const [allBlogsData, setAllBlogs] = useState(null);
  const [categories, setcategories] = useState([]);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "post"]{
            _id,
            title,
            slug,
            "categories": categories[] -> title,
            lien,
            mainImage {
              asset -> {
                _id,
                url
              }
            },
            _createdAt,
            publishedAt,
            description
          } | order(_createdAt desc)`
      )
      .then((data) => {
        setAllBlogs(data);
      })
      .catch(console.error);

    client
      .fetch(
        `*[_type == "category"] {
          title
        }`
      )
      .then((data) => {
        setcategories(data);
      })
      .catch(console.error);
    console.log(categories);
  }, []);

  return (
    <div className="flex flex-col items-center w-full h-screen relative">
      <div className="flex flex-col relative w-full h-screen pb-20 lg:pb-6 px-8 lg:px-4 items-center max-w-2xl lg:max-w-4xl 2xl:max-w-6xl ecran-2000:max-w-7xl">
        <MenuDesktopHorizontal />

        <div className="pt-24 lg:pt-6 flex-1 flex flex-col items-center w-full text-white">
          <div className="relative flex flex-col items-center w-full space-y-8">
            <span
              className="texte-box-jaune text-4xl text-[#ffcb6b] relative tracking-tighter font-semibold font-[Yanone Kaffeesatz] after:content-[''] 
              after:absolute after:block after:h-1 after:bg-[#ffcb6b] 
              after:w-full"
            >
              Blogs
            </span>

            {/* categories */}
            {/* <div className="fixed flex justify-center items-center top-16 right-1 bg-[#ffcb6b] rounded-md shadow w-12 h-12 z-10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6 text-black"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 6h.008v.008H6V6z"
                />
              </svg>

              <ul className="hidden">
                <li>html</li>
              </ul>
            </div> */}
            
            {/* liste des blogs */}
            <ul className="w-full grid grid-cols-1 gap-5 md:grid-cols-2 pb-10">
              {allBlogsData !== null
                ? allBlogsData &&
                  allBlogsData.map((blog) => (
                    <OneBlog
                      key={blog._id}
                      titre={blog.title}
                      categories={blog.categories}
                      lien={blog.lien}
                      description={blog.description}
                      mainImage={blog.mainImage}
                      date={blog.publishedAt}
                    />
                  ))
                : [12, 6, 8, 10, 9, 2].map((_, id) => (
                    <SkeletonBlog key={id} />
                  ))}
            </ul>
          </div>
        </div>

        {/* footer */}
        <div className="lg:hidden">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Blog;
